module.exports = __webpack_public_path__ + "media/images/sns/facebook_icon-8ebec6f2a7065136fa90d4be2450ebaa.png";